module.exports = __webpack_public_path__ + "img/icon-estateManagement.42404fe7.png";